export default "/_next/static/images/b9b9672d8d230b80b9e8ca3733941c4c.jpg";